var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFla = function SvgFla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15642",
    d: "M19.6 19.5c0 .413-.338.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.412 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.916 14.63v.954h1.53c.215 0 .43.216.43.425 0 .198-.215.36-.43.36h-1.53v1.259c0 .21-.15.371-.359.371-.264 0-.426-.161-.426-.371v-3.406c0-.216.163-.372.426-.372h2.105c.264 0 .42.156.42.372a.414.414 0 0 1-.42.408zM8.81 14.21c0-.198.169-.366.379-.366.192 0 .354.169.354.366v3.005h1.63c.588 0 .6.785 0 .785H9.19c-.21 0-.378-.15-.378-.365V14.21M12.392 18c-.192-.108-.312-.324-.192-.576l1.72-3.363c.162-.318.594-.33.744 0l1.69 3.363c.247.468-.48.84-.695.372l-.264-.527h-2.213l-.257.528c-.096.203-.318.246-.533.203m2.577-1.523-.677-1.482-.737 1.483z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.412 0 .75-.337.75-.75v-.75c0 .413-.338.75-.75.75"
  })));
};
export default SvgFla;